export class SaqueBoletoModel {
    accountId: string = '';
    paymentOptions : string[] = ['PIX'];
    person : SaqueBoletoPersonModel = new SaqueBoletoPersonModel();
    value: number = 0;
    endToEndId : string = '';
}

export class SaqueBoletoPersonModel
{
  cpf: string = '';
  email: string = '';
  pixKeyTypes: string = '';
  pixKey: string = '';
  name: string = '';
  userId: string = 'WEB'
}
